import { render, staticRenderFns } from "./DiscountFields.vue?vue&type=template&id=4ae73ecd&"
import script from "./DiscountFields.vue?vue&type=script&lang=js&"
export * from "./DiscountFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports